export class ChatSound
{
    constructor(soundSource) {
        if (soundSource) {
            this._sound = new Audio(soundSource);
        }
    }

    play (looped, ignoreIfPlaying) {
        if (this._sound) {
            try {
                if (ignoreIfPlaying && !this._sound.paused) {
                    return;
                }
                this._sound.currentTime = 0;
                this._sound.muted = false;
                this._sound.loop = looped || false;
                this._sound.play();
            } catch (e) {}
        }
    }

    stop () {
        try {
            if (this._sound && !this._sound.paused) {
                this._sound.pause();
                this._sound.currentTime = 0;
            }
        } catch (e) {}
    };
}